import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment/environment';
import { Observable } from 'rxjs';

/**
 * Sends cookies on calls to the Tungsten API.
 * HttpClient defaults to withCredentials: false, so a cross-origin
 * Set-Cookie from GET /user/me is ignored and later calls omit Cookie.
 */
@Injectable()
export class ApiCredentialsInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (!this.isApiRequest(req.url)) {
      return next.handle(req);
    }

    return next.handle(req.clone({ withCredentials: true }));
  }

  private isApiRequest(url: string): boolean {
    return url === environment.api || url.startsWith(`${environment.api}/`);
  }
}
